import React from 'react';
import { Box, Typography } from '@mui/material';
import ResponsiveDialogue from '../../ResponsiveDialogue/ResponsiveDialogue';
import RoundedButton from '../../RoundedButton/RoundedButton';

interface DirtyFormModalProps {
    open: boolean;
    onClose: () => void;
    onNavigate: () => void;
}

const DirtyFormModal: React.FC<DirtyFormModalProps> = ({ open, onClose, onNavigate }) => {
    return (
        <ResponsiveDialogue
            data-testid="audit-log-dialogue"
            open={open}
            onClose={onClose}
            title="Leave Page?"

        >
            <Box sx={{
							pt: 2
						}}>
                <Typography variant="body1" fontWeight="bold">Your changes will not be saved.</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }}>
                <Box sx={{ pr: 2 }}>
                    <RoundedButton
                        variantStyle="light"
                        variant="outlined"
                        data-testid="back-to-asset-detail-button"
                        onClick={() => {
                            onNavigate();
                            onClose();
                        }}
                    >
                        Leave Page
                    </RoundedButton>
                </Box>
                <Box>
                    <RoundedButton
                        variantStyle="dark"
                        variant="contained"
                        data-testid="continue-to-asset-list-button"
                        onClick={() => onClose()}
                    >
                        Stay On Page
                    </RoundedButton>
                </Box>
            </Box>
        </ResponsiveDialogue>
    );
};

export default DirtyFormModal;
